module.exports = __webpack_public_path__ + "img/CP.3628eb2d.png";